import { Avatar, Box, Stack, Tooltip, Typography } from '@mui/material';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';
import { useLocation, useNavigate } from 'react-router-dom';

interface IMenuItemTooltip {
  menuItem: IBurgerMenuItem;
  setExpandedMenuItem: Function;
}

export const MenuItemTooltip = ({
  menuItem,
  setExpandedMenuItem,
}: IMenuItemTooltip) => {
  const navigate = useNavigate();

  const { pathname } = useLocation();

  return (
    <Tooltip
      title={
        <Stack
          onClick={() => {
            if (!menuItem.subItems) {
              navigate(`/${menuItem.internalLink}`);
              setExpandedMenuItem(null);
            } else setExpandedMenuItem(menuItem);
          }}
        >
          <Typography
            variant='body6'
            sx={{
              whiteSpace: 'nowrap',
            }}
          >
            {menuItem.description}
          </Typography>
        </Stack>
      }
      placement='left'
      enterDelay={100}
      enterNextDelay={100}
      componentsProps={{
        tooltip: {
          sx: {
            m: 0,
            p: '0 16px 0 0',
            bgcolor: 'transparent',
            cursor: 'pointer',
          },
        },
      }}
      PopperProps={{
        style: {
          background:
            `/${menuItem.internalLink}` === pathname ||
            menuItem.subItems?.some(
              (item) => `/${item.internalLink}` === pathname
            )
              ? '#103EB0'
              : '#2860EA',
          height: '54px',
          minWidth: '100px',
          borderRadius: '32px 0 0 32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          padding: '16px 0',
          '&:hover': {
            cursor: 'pointer',
            bgcolor: 'primary.shade_500',
          },
          bgcolor:
            `/${menuItem.internalLink}` === pathname ||
            menuItem.subItems?.some(
              (item) => `/${item.internalLink}` === pathname
            )
              ? 'primary.shade_500'
              : undefined,
        }}
      >
        <Avatar
          alt=''
          src={menuItem.iconUrl}
          sx={{ width: '25px', height: '23px' }}
        />
      </Box>
    </Tooltip>
  );
};
